var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAccordionContext } from '../context/AccordionContext';
import { createContentId, createTriggerId } from '../helpers/generateId';
import { StyledAccordionChevron, StyledAccordionHeader, StyledAccordionIcon, StyledAccordionTrigger, StyledAccordionTriggerContent, } from '../styles/accordion.styled';
export const Header = (_a) => {
    var { icon, iconType, children } = _a, props = __rest(_a, ["icon", "iconType", "children"]);
    const { id, isOpen, toggle } = useAccordionContext();
    return (_jsx(StyledAccordionHeader, { children: _jsxs(StyledAccordionTrigger, Object.assign({ id: createTriggerId(id), type: "button", "aria-expanded": isOpen, "aria-controls": createContentId(id), onClick: toggle, "$hasIcon": icon !== undefined }, props, { children: [icon && _jsx(StyledAccordionIcon, { variant: icon, type: iconType }), _jsx(StyledAccordionTriggerContent, { children: children }), _jsx(StyledAccordionChevron, {})] })) }));
};
